export const initialData = {
  valor: '0,00',
  atividade_id: '',
  tipo_licenca_id: '',
  porte_empreendimento_id: 1,
}
export default initialData;
